import React, { useEffect } from 'react';
import { useAlerts } from 'components/Alerts';

const UnsubResubToast = () => {
  const alerts = useAlerts();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('unsubscribed')) alerts.success('You are now unsubscribed');
    if (searchParams.has('resubscribed')) alerts.success('Resubscribed!');
  }, []);

  return <></>;
};

export default UnsubResubToast;
